// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import { useLocation, Navigate } from 'react-router-dom';
import { useLocale } from '../../hooks/useLocale.js';
import { usePageTitle } from '../../hooks/usePageTitle.js';

/**
 * Confirmation page shown after successful intake submission.
 * Displays the ticket reference number and next steps.
 *
 * See: docs/product/phases/phase-1/sprint-1.0.0.md - A.4 Submission Confirmation
 */
export function IntakeConfirmationPage() {
  usePageTitle('Intake Confirmation');
  const location = useLocation();
  const { t } = useLocale();

  const state = location.state as { referenceNumber?: string; language?: string } | null;

  // Redirect if accessed directly without submission
  if (!state?.referenceNumber) {
    return <Navigate to="/rights-request" replace />;
  }

  return (
    <div className="confirmation-page">
      <div className="confirmation-container">
        <h1>{t.intake.confirmation.title}</h1>
        <p>{t.intake.confirmation.message}</p>
        <div className="reference-number">
          <strong>{state.referenceNumber}</strong>
        </div>
        <p>{t.intake.confirmation.next_steps}</p>
      </div>
    </div>
  );
}
